module.exports = __webpack_public_path__ + "2652a0a7d711b63ce659a2be68af84a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-768.jpg
// module id = 432
// module chunks = 0